import { MsalProvider } from '@azure/msal-react';
import { IPublicClientApplication } from '@azure/msal-browser';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import NavMenu from './features/navmenu/NavMenu';
import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route, Navigate,
} from 'react-router-dom';
import { Health } from './features/health/Health';
import { Profile } from './features/profile/Profile';
import { Layout } from './components/Layout/Layout';
import {Customers} from "./features/customers/Customers";
import {Notes} from "./features/note/Notes";
import {AddNote} from "./features/note/AddNote";
import NoteCreated from "./features/note/NoteCreated";
import {EditNote} from "./features/note/EditNote";
import {Footer} from "./components/Footer/Footer";
import {EditCustomer} from "./features/customers/EditCustomer";
import {AddCustomer} from "./features/customers/AddCustomer";

type AppProps = {
  pca: IPublicClientApplication;
};

const App = ({ pca }: AppProps) => {

  return (
    <MsalProvider instance={pca}>
      <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
        <Router>
          <NavMenu />
          <Layout>
            <Routes>
              <Route path="/" element={<Navigate replace to="/notes" />} />
              <Route path="/health" element={<Health />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/customers/:id/edit" element={<EditCustomer />} />
              <Route path="/customers/add" element={<AddCustomer />} />
              <Route path="/notes" element={<Notes />} />
              <Route path="/notes/add-note" element={<AddNote />} />
              <Route path="/notes/created/:id" element={<NoteCreated />} />
              <Route path="/notes/:id/edit" element={<EditNote />} />
            </Routes>
          </Layout>
          <Footer />
        </Router>
      </MsalAuthenticationTemplate>
    </MsalProvider>
  );
};

export default App;
